import { createModalContext, useModalState } from '@/common/app/modal'
import { WidgetLayoutType } from '@/common/model/recommend/widget'
import { ChildProps } from '@/common/util/props'

import VisualCssEditorModal from '@/components/container/modal/widget/visualCssEditor/VisualCssEditorModal'

interface VisualCssEditorModalState {
  siteId: number
  widgetPageId: number | null
  layoutType: WidgetLayoutType
  titleTemplate: string
  maxItems: number
  useTitle: boolean
  currentCss: string
  onApply: (values: {
    custom_css: string
    layout_type: WidgetLayoutType
    max_items: number
    title_template: string
    use_title: boolean
    widget_page_id: number | null
  }) => void
}

const defaultValue = {
  siteId: 0,
  widgetPageId: 0,
  layoutType: WidgetLayoutType.GRID,
  titleTemplate: '',
  maxItems: 0,
  useTitle: false,
  currentCss: '',
  onApply: () => {}
}

export const VisualCssEditorModalContext =
  createModalContext<VisualCssEditorModalState>(defaultValue)

const VisualCssEditorModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<VisualCssEditorModalState>(defaultValue)
  return (
    <VisualCssEditorModalContext.Provider value={state}>
      {children}
      <VisualCssEditorModal />
    </VisualCssEditorModalContext.Provider>
  )
}

export default VisualCssEditorModalProvider
